module.exports = __webpack_public_path__ + "img/home_menu_6_default.e228e675.png";